import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
// eslint-disable-next-line import/extensions
import {connect} from 'redux-zero/react';
import {FormattedMessage, injectIntl} from 'react-intl';

import {withLocaleContext} from '../../../locales/locale-context.js';
import {actions} from '../../../shared/store.js';
import PageHeader from '../../../components/page-header/page-header.component.js';
import EventsService from './events.service.js';
import {PrimaryButton} from '../../../components/ui-toolkit/buttons.js';
import EventCard from './event-card.component.js';
import NotImplemented from '../../../components/not-implemented/not-implemented.js';

import './../news-events.scss';

const limitEventsByRequest = 5;
const today = new Date();

class EventsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			clicked: 'Events'
		};
	}

	static prefetchUpcomingEvents = (language, skip = 0) =>
		EventsService.getUpcomingEvents({
			language,
			limit: limitEventsByRequest,
			skip,
			date: today
		});

	static prefetchPastEvents = (language, skip = 0) =>
		EventsService.getPastEvents({
			language,
			limit: limitEventsByRequest,
			skip,
			date: today
		});

	componentDidMount() {
		const {setLoading, events} = this.props;
		if (!events) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			localeContext: {locale}
		} = this.props;

		if (prevProps.localeContext.locale.value !== locale.value) {
			this.fetchData();
		}
	}

	loadMoreUEvents = () => {
		const {upcomingEvents} = this.props;
		this.fetchData(upcomingEvents.length, true, false);
	};

	loadMorePEvents = () => {
		const {pastEvents} = this.props;
		this.fetchData(pastEvents.length, false, true);
	};

	fetchData(skip = 0, upcomingOnly = false, pastOnly = false) {
		const {
			setLoading,
			setUpcomingEvents,
			setPastEvents,
			setTotalUEvents,
			setTotalPEvents,
			upcomingEvents,
			pastEvents,
			localeContext: {locale}
		} = this.props;

		if (upcomingEvents === null && pastEvents === null) {
			setLoading(true);
		}

		if (!pastOnly) {
			EventsPage.prefetchUpcomingEvents(locale.value, skip)
				.then(({data, total}) => {
					if (upcomingEvents !== null && skip !== 0) {
						const oldUEvents = Array.from(upcomingEvents);
						setUpcomingEvents(oldUEvents.concat(data));
					} else {
						setUpcomingEvents(data);
					}
					setTotalUEvents(total);
					setLoading(false);
					if (upcomingOnly) return;
				})
				.catch(() => {
					setLoading(false);
					this.setState({
						hasError: true
					});
				});
		}

		if (!upcomingOnly) {
			EventsPage.prefetchPastEvents(locale.value, skip)
				.then(({data, total}) => {
					if (pastEvents !== null && skip !== 0) {
						const oldPEvents = Array.from(pastEvents);
						setPastEvents(oldPEvents.concat(data));
					} else {
						setPastEvents(data);
					}
					setTotalPEvents(total);
					setLoading(false);
				})
				.catch(() => {
					setLoading(false);
					this.setState({
						hasError: true
					});
				});
		}
	}

	render() {
		const {hasError} = this.state;
		const {
			intl,
			upcomingEvents,
			pastEvents,
			totalUEvents,
			totalPEvents
		} = this.props;

		if (hasError) {
			return <NotImplemented/>;
		}

		return (
			<div className="news-events-page">
				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.news_events'
						})}
					</title>
				</Helmet>
				<section className="header">
					<div className="tab-container">
						<div className="container container-fluid">
							<div className="row tab-switcher">
								<PrimaryButton link={`/news`}>
									<FormattedMessage id="navigation.news"/>
								</PrimaryButton>
								<PrimaryButton link={`/events`} extraClasses="current">
									<FormattedMessage id="navigation.events"/>
								</PrimaryButton>
							</div>
						</div>
					</div>
					<div className="container container-fluid">
						<div className="row center-md">
							<div className="col-xs-12 col-md-12 center-xs center-md">
								<PageHeader
									title={<FormattedMessage id="navigation.events"/>}
								/>
							</div>
							<div className="col-xs-12 col-md-6 center-xs center-md">
								<h2>
									<FormattedMessage id="events.title"/>
								</h2>
							</div>
						</div>
					</div>
				</section>
				<section className="container container-fluid events-section">
					<div className="upcoming-section">
						{upcomingEvents.length > 0 && (
							<h4 className="events-title">
								{intl.formatMessage({
									id: 'events.upcoming'
								})}
							</h4>
						)}
						{upcomingEvents.map(event => (
							<div key={event.title} className="events-upcoming">
								<EventCard event={event}/>
							</div>
						))}
						{upcomingEvents.length < totalUEvents && (
							<div className="col-xs-12 center-xs center-md load-more">
								<PrimaryButton onclick={this.loadMoreUEvents}>
									<FormattedMessage id="news.load_more_results"/>
								</PrimaryButton>
							</div>
						)}
					</div>
					{pastEvents.length > 0 && (
						<div className="past-section">
							<h4 className="events-title">
								{intl.formatMessage({
									id: 'events.past'
								})}
							</h4>
							{pastEvents.map(event => (
								<div key={event.title} className="events-past">
									<EventCard event={event}/>
								</div>
							))}
							{pastEvents.length < totalPEvents && (
								<div className="col-xs-12 center-xs center-md load-more">
									<PrimaryButton onclick={this.loadMorePEvents}>
										<FormattedMessage id="news.load_more_results"/>
									</PrimaryButton>
								</div>
							)}
						</div>
					)}
				</section>
			</div>
		);
	}
}

const mapToProps = ({
											news,
											totalNews,
											upcomingEvents,
											pastEvents,
											totalUEvents,
											totalPEvents
										}) => ({
	news,
	totalNews,
	upcomingEvents,
	pastEvents,
	totalUEvents,
	totalPEvents
});

export default withLocaleContext(
	injectIntl(connect(mapToProps, actions)(EventsPage))
);

export {EventsPage};
